import { useAppSelector } from '../../../../reduxService/hooks';
import { IProject } from '../../../api/IApiResponse';
import { unit as unitEnum } from '../../../enum/project';

/**
 * Hook for accessing project data from Redux store
 * Single responsibility: Redux state management
 */
export const useProjectData = () => {
    // Redux Selectors
    const projectDataFromState = useAppSelector(state => state.Dynamic.project?.data);
    const projectUnitFromState = useAppSelector(state => state.Dynamic.project?.data?.unit);
    const isNewProject = useAppSelector(state => state.Dynamic.project?.data?.newProject ?? false);

    // Derived state
    const hasProject = !!projectDataFromState;
    const projectGuid = projectDataFromState?.guid;
    const projectType = projectDataFromState?.type;
    const projectMethod = projectDataFromState?.method;
    const hasBeenRan = projectDataFromState?.hasBeenRan ?? false;
    const projectUnit = projectUnitFromState || unitEnum.SI;

    return {
        projectData: projectDataFromState,
        projectUnit,
        isNewProject,
        hasProject,
        projectGuid,
        projectType,
        projectMethod,
        hasBeenRan,
    };
};

export type UseProjectDataReturn = ReturnType<typeof useProjectData>;
